import { ViewGuidesButton, OrderPartButton } from './part_buttons';
import { withOrderContext } from '../Providers/orderContext';
import CopyIcon from '../Generic/clipboard';
import { fromWiki } from '../Generic/fromWiki';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';

const MiscPartRow = ({ datapoint }: { datapoint: iFixitHotSpotItem }) => {
   const sku = fromWiki(datapoint, 'sku') || '';
   const name = fromWiki(datapoint, 'name') || datapoint.description;
   const brand = fromWiki(datapoint, 'brand') || '';

   const itemWikiUrl = fromWiki(datapoint, 'url') || '';

   const copyText = `${brand} ${datapoint.description} ${sku}`;

   return (
      <div className="flex justify-between w-full py-3 px-4 text-gray-800 leading-normal">
         <div className="flex-1">
            <a
               href={itemWikiUrl}
               target="_blank"
               rel="noopener noreferrer"
               className="text-base text-left text-gray-800 hover:no-underline visited:text-gray-800"
            >
               {name}
            </a>
            {sku && <p className="text-sm text-left text-gray-600">{sku}</p>}
         </div>
         <div className="flex items-center">
            <CopyIcon copyText={copyText} />
         </div>
         <div className="flex justify-end flex-wrap items-center gap-2">
            <ViewGuidesButton data={datapoint} />
            <OrderPartButton data={datapoint} />
         </div>
      </div>
   );
};

export default withOrderContext(MiscPartRow);
